export default __webpack_public_path__ + "static/media/mild.93c47af1.svg";